var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-main p-4",attrs:{"type":"submit","disabled":_vm.loading}},[(_vm.loading)?_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fas', 'spinner'],"spin":""}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }